import { render, staticRenderFns } from "./UCProductHeroSection.vue?vue&type=template&id=421abc30&scoped=true&"
import script from "./UCProductHeroSection.vue?vue&type=script&lang=ts&"
export * from "./UCProductHeroSection.vue?vue&type=script&lang=ts&"
import style0 from "./UCProductHeroSection.vue?vue&type=style&index=0&id=421abc30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421abc30",
  null
  
)

export default component.exports